import React from 'react';

const Card = ({ title, children, className = '' }) => {
  return (
    <div
      className={`
        bg-white rounded-lg shadow-md
        w-full max-w-full
        px-3 py-4 sm:px-5 sm:py-5
        ${className}
      `}
    >
      {title && (
        <h3 className="text-base sm:text-lg xl:text-2xl font-bold tertiary-text-color mb-3 text-center md:text-left">
          {title}
        </h3>
      )}

      {/* IMPORTANT: allow horizontal scroll for tables */}
      <div className="w-full overflow-x-auto">{children}</div>
    </div>
  );
};

export default Card;
